import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { SuspensionReason } from './suspension-reason';

@inheritSerialization(AbstractModel)
export class PersonSuspension extends AbstractModel {
  @autoserialize
  active: boolean;

  @autoserialize
  personId: number;

  @autoserializeAs(Date)
  effectiveAt: Date;

  @autoserialize
  durationHours: number;

  @autoserialize
  effective: boolean;

  @autoserializeAs(SuspensionReason)
  suspensionReason: SuspensionReason;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  modifiedByUserId: number;

  @autoserialize
  deactivatedByUserId: number;

  @autoserialize
  note: string;

  @autoserialize
  expired: boolean;

  @autoserialize
  deactivatedAt: Date;

  /**** Serialization ****/

  static OnSerialized(instance: PersonSuspension, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.effectiveAt)) {
      json.effectiveAt = DateUtil.serializeInstant(instance.effectiveAt);
    }
  }

  static OnDeserialized(instance: PersonSuspension, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['effectiveAt'])) {
      instance.effectiveAt = DateUtil.deserializeInstant(json['effectiveAt']);
    }
  }
}
